import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Loader2, Save, Sparkles } from "lucide-react";
import { API } from "../../data";

export default function ConciergeSettings({ token }) {
  const [notes, setNotes] = useState("");
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const headers = { Authorization: `Bearer ${token}` };

  const load = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/admin/concierge-notes`, { headers });
      setNotes(data.notes || "");
    } finally {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  useEffect(() => {
    load();
  }, [load]);

  const save = async () => {
    setSaving(true);
    try {
      await axios.put(`${API}/admin/concierge-notes`, { notes }, { headers });
      toast.success("Concierge aggiornato: le note sono attive subito.");
    } catch {
      toast.error("Errore nel salvataggio");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div data-testid="concierge-settings" className="rounded-[1.75rem] bg-white p-8 ring-1 ring-navy/10">
      <div className="flex items-start gap-4">
        <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-navy text-sky">
          <Sparkles className="h-5 w-5" />
        </span>
        <div>
          <h2 className="font-display text-2xl font-semibold text-navy">Addestra il concierge</h2>
          <p className="mt-2 max-w-2xl text-sm leading-relaxed text-mute">
            Scrivi qui tutto ciò che il concierge deve sapere: lista completa delle strutture, regole casa, orari, FAQ, prezzi extra, parcheggi, convenzioni. Ogni modifica è attiva immediatamente, in italiano e in inglese.
          </p>
        </div>
      </div>
      <textarea
        data-testid="concierge-notes-textarea"
        rows={12}
        value={notes}
        onChange={(e) => setNotes(e.target.value)}
        disabled={loading}
        placeholder={"Esempio:\n- Villa Libera: 6 ospiti, jacuzzi, check-in dalle 15:00, animali non ammessi\n- Parcheggio gratuito in tutte le strutture\n- Sconto 10% per soggiorni oltre 7 notti"}
        className="mt-6 w-full rounded-2xl border border-navy/15 bg-warm px-5 py-4 font-mono text-sm leading-relaxed text-ink placeholder-mute/60 focus:border-sky focus:outline-none focus:ring-2 focus:ring-sky/25"
      />
      <div className="mt-5 flex items-center gap-4">
        <button data-testid="concierge-notes-save" onClick={save} disabled={saving || loading} className="btn-primary !px-6 !py-3 text-[13px]">
          {saving ? <Loader2 className="h-4 w-4 animate-spin" /> : <Save className="h-4 w-4" />}
          {saving ? "Salvataggio…" : "Salva e attiva"}
        </button>
        <span className="text-xs font-semibold text-mute">{notes.length} / 8000 caratteri</span>
      </div>
    </div>
  );
}
